<template>
  <a href="#" @click="downloadFile()">{{ displayFileIdentifier }}</a>
</template>
<script>
export default {
  props: ["fileIdentifier"],
  methods: {
    downloadFile() {
      window.open(`${process.env.VUE_APP_API_URL}/files/${this.fileIdentifier}`, "_blank");
    }
  },
  computed: {
    displayFileIdentifier() {
      const url = new URL("/" + this.fileIdentifier, "http://localhost");
      const searchParams = url.searchParams;

      if (searchParams.has("name")) {
        return searchParams.get("name");
      }
      return this.fileIdentifier;
    }
  }
};
</script>
